import angular from 'angular';
import contactDetailsPreview from './contactDetailsPreview';

export default angular
  .module('components.contactDetailsPreview', [])
  .component('contactDetailsPreview', contactDetailsPreview).name;
